import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { useAppSelector } from '@core/Store/hooks'
import { FollowMeFeedParams } from '@core/Areas/FollowMe/helpers/api/types'

export const useRefetchFeedDataOnBetslipClosed = (location: FollowMeFeedParams['feedType']) => {
  const isOpen = useAppSelector(state => state.appHeader.isBetSlipOpen)
  const queryClient = useQueryClient()
  const timeOpenedRef = React.useRef<number | null>(null)

  React.useEffect(() => {
    if (isOpen) {
      timeOpenedRef.current = Date.now()
    } else if (timeOpenedRef.current !== null) {
      const openDuration = Date.now() - timeOpenedRef.current
      if (openDuration >= 60000) {
        queryClient.invalidateQueries({
          queryKey: [...queryKeys.followMeSharedBetsFeedBase(location)],
          exact: false,
        })
      }
      timeOpenedRef.current = null
    }
  }, [isOpen, queryClient, location])
}
